<script lang="ts">
  import FizzStyles from "@shared/svelte/Components/FizzStyles.svelte";
  import LayoutStore from "@shared/svelte/Stores/LayoutStore";
  import ProviLogoLink from "@shared/svelte/Components/Layout/Header/ProviLogoLink.svelte";

  export let showLoginAndSignupButtons: boolean = true;

</script>

<FizzStyles>
  <header class="fizz-surface-brand header" class:fizz-inset-squish-24={$LayoutStore.isDesktop}>
    <div
      class="fizz-container fizz-full-width fizz-flex-row fizz-space-between"
      class:fizz-inset-vertical-16={$LayoutStore.isMobile}
    >
      <ProviLogoLink extraClassNames="fizz-text-inverse fizz-icon-logo" />
      {#if showLoginAndSignupButtons}
        <div
          class="fizz-flex-row"
          class:fizz-inline-16={$LayoutStore.isMobile}
          class:fizz-inline-4={$LayoutStore.isDesktop}
        >
          <a
            class="fizz-button fizz-button-small"
            href="/sign-up?ref=1"
            target="_blank"
            rel="noopener noreferrer">Sign up</a
          >
          <a
            class="fizz-button-secondary fizz-button-small"
            href="/users/sign_in?ref=1"
            target="_blank"
            rel="noopener noreferrer">Log In</a
          >
        </div>
      {/if}
    </div>
  </header>
</FizzStyles>
